export default __webpack_public_path__ + "static/news1-138dd9807929b7c1a93d6108169e72cb.webp";